import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import constant from "config/constant";
import { get } from "../../util/axiosLib";
import ls from "util/secureStorage";
import { logger } from "util/logger";
import { wrapBaseApi } from "util/apiWrapper";

const getToken = () => ls.get(constant.AUTH_TOKEN_KEY).token;

const getHeaders = (token = null) => ({
  authorization: token ?? getToken(),
  "Content-Type": "application/json",
});

const initialState = {
  status: "idle",
  notifications: [],
  totalCount: 0,
  totalUnseenCount: 0,
};

export const fetchNotifications = createAsyncThunk(
  "notifications/fetchUserNotification",
  async (data, _thunk) => {
    const { token, page } = data;
    const URL = wrapBaseApi(`/notifications?page=${page}&limit=10`);
    try {
      const response = await get(URL, getHeaders(token));
      return response;
    } catch (error) {
      logger("Notification:", error);
    }
  }
);

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchNotifications.fulfilled, (state, { payload }) => {
      state.notifications = payload.data.data.notifications;
      state.totalCount = payload.data.data.totalCount;
      state.totalUnseenCount = payload.data.data.totalUnseenCount;
      state.status = "success";
    });

    builder.addCase(fetchNotifications.pending, (state) => {
      state.status = "loading";
    });

    builder.addCase(fetchNotifications.rejected, (state) => {
      state.status = "error";
    });
  },
});

// export const {} = notificationSlice.actions
export default notificationSlice.reducer;
